import { render } from "./WealthDeclaration.vue?vue&type=template&id=470502a5&scoped=true"
import script from "./WealthDeclaration.vue?vue&type=script&lang=js"
export * from "./WealthDeclaration.vue?vue&type=script&lang=js"

import "./WealthDeclaration.vue?vue&type=style&index=0&id=470502a5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-470502a5"]])

export default __exports__